import { render, staticRenderFns } from "./FieldsetDisplayNameParts.vue?vue&type=template&id=3450fbf1&scoped=true"
import script from "./FieldsetDisplayNameParts.vue?vue&type=script&lang=ts"
export * from "./FieldsetDisplayNameParts.vue?vue&type=script&lang=ts"
import style0 from "./FieldsetDisplayNameParts.vue?vue&type=style&index=0&id=3450fbf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3450fbf1",
  null
  
)

export default component.exports